import { createTheme } from '@mantine/core';

export const spacing = createTheme({
  spacing: {
    /** 4px */
    xxsmall: '0.25rem',
    /** 4px */
    xxs: '0.25rem',
    /** 8px */
    xsmall: '0.5rem',
    /** 8px */
    xs: '0.5rem',
    /** 12px */
    small: '0.75rem',
    /** 12px */
    sm: '0.75rem',
    /** 16px */
    medium: '1rem',
    /** 16px */
    md: '1rem',
    /** 24px */
    large: '1.5rem',
    /** 24px */
    lg: '1.5rem',
    /** 32px */
    xlarge: '2rem',
    /** 32px */
    xl: '2rem',
    /** 64px */
    xxlarge: '4rem',
    /** 64px */
    xxl: '4rem',
  },
});
